<!-------------searching---------------->
<div class="input-group Top SearchSize">
    <input type="search" class="form-control form-control-lg " placeholder="search customer" id="search" name="search" [(ngModel)]="search">
    <div class="input-group-append">
    <button type="submit" class="btn btn-lg btn-default" (click)="Search();">
    <i class="fa fa-search"></i>
    </button>
    </div>
    </div>

<!---------------------------------new ui---------------------------------------------------->


    <section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Customers</h1>
    </div>
    </div>
   
    </section>
    <!--------------loader-------------------------->
    <div *ngIf=loaderShown class="loader"></div>
    <!----------------------------------------------->
    
    <section class="content">
    
    <div class="card" *ngIf=CardShown>
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 25%">
    Name
    </th>

    <th style="width: 15%">
    Mobile
    </th>

    <th style="width: 15%">
    Email
    </th>
    
     
    <th style="width: 15%">
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.customer_name}}
    </a>
    </td>
    
    <td>
    {{c.customer_mobile}}
    </td>

    
    <td>
    {{c.customer_email}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)='CustomerDetails();getValue(c.customer_id)'>
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left" (click)='getValue(c.customer_id);EditCustomer();'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    <!--
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    -->
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!---------paging----------->
<div *ngIf=CardShown>
<div class="row">
    <div class="col-sm-12 col-md-5">
    <div class="col-sm-12 col-md-7"><div class="dataTables_paginate paging_simple_numbers " id="example2_paginate">
    </div></div></div></div>
<div class="col-sm-12 col-md-7">
    <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
        <ul class="pagination">
            <li class="paginate_button page-item previous" id="example2_previous">
            <button  (click)="clicks_previous()" [disabled]="prv_status" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link">Previous</button></li>

            <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link">{{count+1}}</a></li>
           
            <li class="paginate_button page-item next" id="example2_next">
            <button (click)="clicks_next()" [disabled]="next_status" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</button></li>
        </ul>
    </div></div>
</div> 